import './gallery.css';
import AssetImg from '../lib/asset-img';
import { useState, useEffect, Children } from 'react';

export function FromParameters({ pageID }) {
    const [numImgs, setNumImgs] = useState(null);

    useEffect(() => {
        if (pageID !== null) {
            fetch(`/v1/api/pages/${pageID}/parameters/imgs`)
                .then(res => res.json())
                .then(data => setNumImgs(data.range))
                .catch(err => console.error('Error fetching page parameters:', err));
        }
    }, [pageID]);

    return <Gallery>
        {[...Array(numImgs)].map((_, i) => {
            return {
                img: `/v1/api/pages/${pageID}/parameters/imgs/${i}`,
                desc: `/v1/api/pages/${pageID}/parameters/descriptions/${i}`
            }
        })}
    </Gallery>
}

export function GalleryCard({id, img, desc}) {
    const [toggled, setToggled] = useState(false);
    const [description, setDescription] = useState(null);

    useEffect(() => {
        if (desc !== null) {
            fetch(`${desc}/$blob`)
                .then(res => res.ok ? res.text() : Promise.reject())
                .then(text => setDescription(text))
                .catch(err => console.error('Error fetching description:', err));
        }
    }, [desc]);

    return <div className='gallery-card' onClick={() => setToggled(!toggled)}>
        {img && <AssetImg url={img} />}
        {toggled && description && <div id={id} className='backing'><div className='description' dangerouslySetInnerHTML={{ __html: description }} /></div>}
    </div>
}

export default function Gallery({ children }) {
    return <div className='gallery'>
        {Children && children.map((item, i) => (
            <GalleryCard id={i} img={item.img} desc={item.desc} />
        ))}
    </div>
}